import { StrictMode } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import App from "./App";
import ErrorPage from "./pages/ErrorPage";
import "@e-seikatsu/design-system/dist/tokens/index.css";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
root.render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
